























import { defineComponent, computed, PropType } from '@vue/composition-api';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import SuccessCard from '@front-app/components/cards/state/SuccessCard.vue';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import EventPage from '@front-app/modules/event/components/EventPage.vue';
import { checkIfEventVisibleToUser } from '@front-app/util/permission';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { useEventStore } from '@front-app/modules/event/store/Event';
import { EventNotification } from '@front-app/services/EventsApi/EventModel';

export default defineComponent({
	components: {
		ColumnContainer,
		ErrorCard,
		PaddedContent,
		SuccessCard,
		EventPage,
	},
	props: {
		eventId: {
			type: String,
			required: true,
		},
		eventReminder: {
			type: Object as PropType<EventNotification>,
			required: true,
		},
		isPostCreateSuccess: Boolean,
	},
	setup(props) {
		const event = computed(() => useEventStore().getById(props.eventId));
		const isEventVisibleToUser = computed(() => checkIfEventVisibleToUser(CurrentUserStore.isCsr.value, event.value));

		return {
			event,
			isEventVisibleToUser,
		};
	},
});
